// JARS 21.10.2026 (Ladezeit): Der Leuchtpuls am Kaufknopf und an der Versand-Zeitleiste ist eine Endlos-Animation auf
// box-shadow. Sie kostet in jedem Bild Rechenzeit, auch wenn der Knopf gar nicht zu sehen ist. Dieses Skript hält sie an,
// solange das Element mehr als 200 px außerhalb des Bildes ist, und lässt sie davor weiterlaufen.
// Angehalten wird nur über das Attribut data-jars-puls="aus" am Element (Regeln: assets/jars.css und
// blocks/jars-versand-zeitleiste.liquid). Ohne IntersectionObserver oder ohne dieses Skript läuft alles wie bisher.
// Eingebunden nur auf Produktseiten (snippets/jars-kopf.liquid).
//
// Zweiter Teil (Code-Review 21.10.2026): Bilder der Produktbeschreibung sind lazy (snippets/text.liquid, data-jars-lazy).
// Liegen sie in einem Akkordeon (.jars-acc-content, zugeklappt display:none), würden sie erst beim Aufklappen laden. Nach dem
// load-Ereignis werden sie deshalb auf eager gestellt und laden wie bisher vorab, nur nicht mehr vor dem ersten Produktbild.
(function () {
  'use strict';
  function akkordeonBilder() {
    var bilder = document.querySelectorAll('.jars-acc-content img[data-jars-lazy]');
    for (var i = 0; i < bilder.length; i++) bilder[i].loading = 'eager';
  }
  if (document.readyState === 'complete') akkordeonBilder();
  else window.addEventListener('load', akkordeonBilder, { once: true });
})();

(function () {
  'use strict';
  if (window.jarsPuls || !('IntersectionObserver' in window)) return;

  var ATTR = 'data-jars-puls';
  var ZIELE = 'button[name="add"], .bcs-shipping-step.is-active .bcs-shipping-icon';
  var imBild = new WeakMap(); // Element -> letzter Stand des Beobachters (true/false)
  var beobachtet = [];

  function setzen(el) {
    if (imBild.get(el) === false) {
      if (el.getAttribute(ATTR) !== 'aus') el.setAttribute(ATTR, 'aus');
    } else if (el.hasAttribute(ATTR)) {
      el.removeAttribute(ATTR);
    }
  }

  var io = new IntersectionObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      imBild.set(eintraege[i].target, eintraege[i].isIntersecting);
      setzen(eintraege[i].target);
    }
  }, { rootMargin: '200px' });

  // Neue Elemente beobachten, entfernte abmelden und den Zustand neu setzen: Horizons morph entfernt beim
  // Variantenwechsel fremde Attribute am Kaufknopf, die Galerie und Teile der Kaufbox werden dabei ersetzt.
  function abgleichen() {
    var rest = [];
    for (var i = 0; i < beobachtet.length; i++) {
      if (beobachtet[i].isConnected) rest.push(beobachtet[i]);
      else io.unobserve(beobachtet[i]);
    }
    beobachtet = rest;
    var liste = document.querySelectorAll(ZIELE);
    for (var j = 0; j < liste.length; j++) {
      var el = liste[j];
      if (beobachtet.indexOf(el) < 0) {
        beobachtet.push(el);
        io.observe(el);
      } else {
        setzen(el);
      }
    }
  }

  function spaeter() {
    setTimeout(abgleichen, 0);
  }

  window.jarsPuls = { abgleichen: abgleichen };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abgleichen);
  else abgleichen();
  document.addEventListener('variant:update', spaeter);
  document.addEventListener('shopify:section:load', spaeter);
})();
